import { supportType_Bug, supportType_Feedback } from './types.js';
export const SupportType_LabelMap = {
    [supportType_Bug]: 'Bug',
    [supportType_Feedback]: 'Feedback',
};
//# sourceMappingURL=consts.js.map